import { render, staticRenderFns } from "./MobilePOSView.vue?vue&type=template&id=37ff5121&scoped=true"
import script from "./MobilePOSView.vue?vue&type=script&lang=js"
export * from "./MobilePOSView.vue?vue&type=script&lang=js"
import style0 from "./MobilePOSView.vue?vue&type=style&index=0&id=37ff5121&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ff5121",
  null
  
)

export default component.exports